import { IssueDetail, type IssueType } from '@strata/react-status-icons';
import {
    type OpportunityStatus,
    OpportunityStatusIndicator,
} from '@strata/react-status-indicators';

export const determineStatus = (issues: IssueType[]): OpportunityStatus => {
    if (issues.includes(IssueDetail.IssueTypes.AUTH_EXPIRED))
        return OpportunityStatusIndicator.Statuses.CLOSED;
    if (issues.includes(IssueDetail.IssueTypes.WAIT_FOR_CLAIM))
        return OpportunityStatusIndicator.Statuses.AWAITING_CLAIM;
    if (issues.includes(IssueDetail.IssueTypes.WAIT_FOR_AUTH))
        return OpportunityStatusIndicator.Statuses.AWAITING_AUTH;
    return OpportunityStatusIndicator.Statuses.INCOMPLETE;
};
